import { useTranslation } from 'react-i18next';

import { gql, useMutation } from '@apollo/client';
import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui';

import { GET_ASSIGNED_TIME_STRIPES } from 'src/hooks/time-stripes/get-time-stripes.hook';

import { GET_GANTT_RECORDS_BY_RANGE } from './get-gantt-records-by-range.hook';

const MOVE_GANTT_RECORD_ENTRY = gql`
  mutation moveRecordEntry($payload: MoveRecordEntryInput!) {
    moveRecordEntry(payload: $payload) {
      type
      conflicts
    }
  }
`;

export const useMoveRecordEntry = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
  const { t } = useTranslation(['common', 'employee']);

  const [moveRecordEntry] = useMutation(MOVE_GANTT_RECORD_ENTRY, {
    refetchQueries: [GET_GANTT_RECORDS_BY_RANGE, GET_ASSIGNED_TIME_STRIPES],
    onCompleted: onSuccess,
    onError: (error: any) => {
      showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('notifications.error.title'),
        ...(error && { description: error.message || error.errorMessage }),
      });
    },
  });

  return moveRecordEntry;
};
